export default {
  'Resize for': '크기 조정',
  'Add 10 videos at most': '최대 10개 비디오를 추가합니다.',
}